export const currencySymbol = {
  GBP: '£',
  AOA: 'Kz',
  AUD: '$',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BMD: '$',
  BND: '$',
  BOB: 'Bs',
  BSD: '$',
  BWP: 'P',
  BYN: 'р.',
  BZD: '$',
  CAD: '$',
  CNY: '¥',
  CRC: '₡',
  CZK: 'Kč',
  DKK: 'kr',
  EGP: '£E',
  ESP: '₧',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GIP: '£',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  ISK: 'kr',
  JMD: '$',
  JPY: '¥',
  KHR: '៛',
  KPW: '₩',
  KRW: '₩',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£L',
  LKR: 'Rs',
  LRD: '$',
  LTL: 'Lt',
  LVL: 'Ls',
  MGA: 'Ar',
  MMK: 'K',
  MNT: '₮',
  MUR: 'Rs',
  MYR: 'RM',
  NAD: '$',
  NGN: '₦',
  NOK: 'kr',
  NPR: 'Rs',
  NZD: '$',
  PHP: '₱',
  PKR: 'Rs',
  PLN: 'zł',
  PYG: '₲',
  RUB: '₽',
  RUR: 'р.',
  SBD: '$',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  SYP: '£',
  THB: '฿',
  TOP: '$T',
  TRY: '₺',
  TTD: '$',
  TWD: '$',
  UAH: '₴',
  USD: '$',
  VEF: 'Bs',
  VND: '₫',
  XCD: '$',
  ZAR: 'R',
};

export const currencySymbolWithText = {
  GBP: '£ (GBP)',
  AOA: 'Kz (AOA)',
  AUD: '$ (AUD)',
  BAM: 'KM (BAM)',
  BBD: '$ (BBD)',
  BDT: '৳ (BDT)',
  BMD: '$ (BMD)',
  BND: '$ (BND)',
  BOB: 'Bs (BOB)',
  BSD: '$ (BSD)',
  BWP: 'P (BWP)',
  BYN: 'р. (BYN)',
  BZD: '$ (BZD)',
  CAD: '$ (CAD)',
  CNY: '¥ (CNY)',
  CRC: '₡ (CRC)',
  CZK: 'Kč (CZK)',
  DKK: 'kr (DKK)',
  EGP: '£E (EGP)',
  ESP: '₧ (ESP)',
  EUR: '€ (EUR)',
  FJD: '$ (FJD)',
  FKP: '£ (FKP)',
  GIP: '£ (GIP)',
  GNF: 'FG (GNF)',
  GTQ: 'Q (GTQ)',
  GYD: '$ (GYD)',
  HKD: '$ (HKD)',
  HNL: 'L (HNL)',
  HRK: 'kn (HRK)',
  HUF: 'Ft (HUF)',
  IDR: 'Rp (IDR)',
  ILS: '₪ (ILS)',
  INR: '₹ (INR)',
  ISK: 'kr (ISK)',
  JMD: '$ (JMD)',
  JPY: '¥ (JPY)',
  KHR: '៛ (KHR)',
  KPW: '₩ (KPW)',
  KRW: '₩ (KRW)',
  KYD: '$ (KYD)',
  KZT: '₸ (KZT)',
  LAK: '₭ (LAK)',
  LBP: '£L (LBP)',
  LKR: 'Rs (LKR)',
  LRD: '$ (LRD)',
  LTL: 'Lt (LTL)',
  LVL: 'Ls (LVL)',
  MGA: 'Ar (MGA)',
  MMK: 'K (MMK)',
  MNT: '₮ (MNT)',
  MUR: 'Rs (MUR)',
  MYR: 'RM (MYR)',
  NAD: '$ (NAD)',
  NGN: '₦ (NGN)',
  NOK: 'kr (NOK)',
  NPR: 'Rs (NPR)',
  NZD: '$ (NZD)',
  PHP: '₱ (PHP)',
  PKR: 'Rs (PKR)',
  PLN: 'zł (PLN)',
  PYG: '₲ (PYG)',
  RUB: '₽ (RUB)',
  RUR: 'р. (RUR)',
  SBD: '$ (SBD)',
  SEK: 'kr (SEK)',
  SGD: '$ (SGD)',
  SHP: '£ (SHP)',
  SRD: '$ (SRD)',
  SSP: '£ (SSP)',
  STD: 'Db (STD)',
  SYP: '£ (SYP)',
  THB: '฿ (THB)',
  TOP: '$T (TOP)',
  TRY: '₺ (TRY)',
  TTD: '$ (TTD)',
  TWD: '$ (TWD)',
  UAH: '₴ (UAH)',
  USD: '$ (USD)',
  VEF: 'Bs (VEF)',
  VND: '₫ (VND)',
  XCD: '$ (XCD)',
  ZAR: 'R (ZAR)',
};
